import React from "react";
import { Icon } from "src/components";
import { theme } from "src/config";
import { Item } from "src/models";
import { IItem } from "src/types";
import styled from "styled-components";

export interface StatusAvatarProps {
  data?:       Item<IItem>,
  className?: string,
  variant?:   StatusAvatarTypes,
}

type StatusAvatarTypes  = 'itemCard' | 'newsFeedItem';

export const StatusAvatar = (props: StatusAvatarProps): JSX.Element => {
  if(!props.data) return null;
  
  return (
    <Container variant={props.variant} className={props.className} color={props.data.getStatusColor}>
      <Icon size={props.variant === 'itemCard' ? 'xsmall' : 'medium'} iconId={props.data.getStatusIcon} color={theme.color.white}/* {getTextColorFromHex(props.data.getStatusColor)} */></Icon>
    </Container>
  );
}
  const Container = styled.div<StatusAvatarProps>`
    border-radius:    50%;
    background-color: ${props => props.color};
    width:            ${(p) => p.variant === 'itemCard' ? "1.8rem" : "4rem"};
    height:           ${(p) => p.variant === 'itemCard' ? "1.8rem" : "4rem"};
    display:          flex;
    align-items:      center;
    justify-content:  center;
  `;